// // src/components/Misc/ResumeBank.js
// import React from 'react';
// import Sidebar from './Sidebar'; // Adjust path if needed
// import DashNavbar from './DashNavbar'; // Adjust path if needed
// import { Container, Card } from 'react-bootstrap';

// // You might need your main CSS file here too if it contains layout styles
// import "../css/dash.css"; // Adjust path if needed

// const ResumeBank = () => {
//     return (
//         <>
//             {/* Assuming DashNavbar is used on all dashboard pages */}
//             <DashNavbar />
//             <div className="wrapper d-flex"> {/* Use wrapper for layout */}
//                 <Sidebar />
//                 <main className="main p-3 w-100"> {/* Use main tag for content area */}
//                     <Container fluid>
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-theme-light">
//                                 <h1 className="h4 gradient-text mb-0">Resume Bank</h1>
//                             </Card.Header>
//                             <Card.Body>
//                                 <p>This is the placeholder page for the Resume Bank.</p>
//                                 {/* Add content related to the resume bank here later */}
//                                 {/* For example, you might display a table or controls to download */}
//                             </Card.Body>
//                         </Card>
//                     </Container>
//                 </main>
//             </div>
//         </>
//     );
// };

// export default ResumeBank; 

// import React, { useState, useEffect, useRef, useMemo } from "react";
// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "../css/dash.css"; // Make sure this path is correct
// import Sidebar from "./Sidebar"; // Make sure this path is correct
// import DashNavbar from "./DashNavbar"; // Make sure this path is correct
// import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form } from "react-bootstrap";
// import Chart from "chart.js/auto";
// import ApplicantDetailsModal from "../ProfileForm/ApplicantDetailsModal"; // Make sure this path is correct

// // --- Define Job Status Options Globally ---
// const jobStatusOptions = [
//     { value: "applied", label: "Applied", bgColor: "bg-info" },
//     { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
//     { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // Added text-dark
//     { value: "selected", label: "Selected", bgColor: "bg-success" },
//     { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
// ];

// // --- ApplicantModal Component (Enhanced UI/UX) ---
// const ApplicantModal = ({
//     applicant,
//     jobapplications,
//     setSuccessMessage,
//     updateJobApplication,
// }) => {
//     // jobStatusOptions is now defined outside, no need to redefine here

//     const [show, setShow] = useState(false);
//     const [personalityData, setPersonalityData] = useState([]);
//     const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
//     const chartRefs = useRef({});
//     const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
//     const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
//     const [currentJobId, setCurrentJobId] = useState(null);
//     const [jobQuestions, setJobQuestions] = useState(null);
//     const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

//     const handleStatusChange = (id, newStatus) => {
//         axios
//             .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
//             .then(() => {
//                 setSuccessMessage("Job status updated successfully");
//                 updateJobApplication(id, newStatus);
//                 setTimeout(() => setSuccessMessage(""), 5000);
//             })
//             .catch((error) => {
//                 console.error("Error updating job status:", error);
//                 // Consider showing an error alert here
//             });
//     };

//     useEffect(() => {
//         setShow(false);
//         const timer = setTimeout(() => {
//             if (applicant && jobapplications) {
//                 setShow(true);
//             }
//         }, 100);

//         return () => {
//             clearTimeout(timer);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//             setCurrentJobId(null);
//             Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//             chartRefs.current = {};
//         };
//     }, [applicant, jobapplications]);

//     useEffect(() => {
//         if (show && applicant?.id) {
//             fetchPersonalityData(applicant.id);
//         }
//     }, [show, applicant]);

//     const fetchPersonalityData = async (applicantId) => {
//         try {
//             const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
//             const personalityResponse = await axios.get(personalityUrl);
//             const fetchedPersonalityData = personalityResponse.data || [];
//             setPersonalityData(fetchedPersonalityData);

//             if (fetchedPersonalityData.length > 0) {
//                 const jobTitleUrl = `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicantId}/`;
//                 const jobTitleResponse = await axios.get(jobTitleUrl);
//                 const jobTitlesMap = (jobTitleResponse.data || []).reduce((acc, job) => {
//                     if (job.job_id) acc[job.job_id] = job.job_title;
//                     return acc;
//                 }, {});
//                 const jobTitles = fetchedPersonalityData.map(data => jobTitlesMap[data.job_id] || `Job ID: ${data.job_id}`);
//                 setPersonalityJobTitles(jobTitles);
//             } else {
//                 setPersonalityJobTitles([]);
//             }

//         } catch (error) {
//             console.error("Error fetching personality assessment data:", error);
//             setPersonalityData([]);
//             setPersonalityJobTitles([]);
//         }
//     };

//     useEffect(() => {
//         Object.values(chartRefs.current).forEach(chart => chart?.destroy());
//         chartRefs.current = {};

//         if (Array.isArray(personalityData)) {
//             personalityData.forEach((data, index) => {
//                 const chartId = `personalityChart-${applicant?.id}-${index}`;
//                 const chartElement = document.getElementById(chartId);
//                 if (chartElement && data && data.job_id) {
//                     try {
//                         const newChart = createDonutChart(data, chartId, data.status);
//                         if (newChart) {
//                             chartRefs.current[index] = newChart;
//                         }
//                     } catch (chartError) {
//                         console.error("Error creating chart:", chartError, "for data:", data);
//                     }
//                 }
//             });
//         }
//     }, [personalityData, applicant?.id]);

//     const onHide = () => {
//         setShow(false);
//     };

//     const createDonutChart = (data, chartId, status) => {
//         if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
//             console.warn(`Invalid chart data for ${chartId}`, data);
//             const ctx = document.getElementById(chartId)?.getContext("2d");
//             if (ctx) {
//                 ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
//                 ctx.font = "12px Arial";
//                 ctx.textAlign = "center";
//                 ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
//             }
//             return null;
//         }
//         const { correct_count, all_count, wrong_count } = data;
//         const ctx = document.getElementById(chartId)?.getContext("2d");

//         if (!ctx) {
//             console.error(`Canvas element with id ${chartId} not found`);
//             return null;
//         }

//         return new Chart(ctx, {
//             type: 'doughnut',
//             data: {
//                 labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
//                 datasets: [{
//                     data: [correct_count, wrong_count],
//                     backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'],
//                     borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
//                     borderWidth: 1,
//                 }]
//             },
//             options: {
//                 responsive: true,
//                 maintainAspectRatio: false,
//                 cutout: '60%',
//                 plugins: {
//                     legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
//                     title: { display: false },
//                     tooltip: {
//                         callbacks: {
//                             label: function (context) {
//                                 let label = context.label || '';
//                                 if (label) { label += ': '; }
//                                 const value = context.parsed;
//                                 const total = context.dataset.data.reduce((a, b) => a + b, 0);
//                                 const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
//                                 label += `${value} (${percentage})`;
//                                 return label;
//                             }
//                         }
//                     }
//                 }
//             }
//         });
//     };

//     const handleShowSubmittedAnswers = async (applicantId, jobId) => {
//         setCurrentJobId(jobId);
//         setFilteredSubmittedAnswers(null);
//         setJobQuestions(null);
//         setAllSubmittedAnswers(null);
//         setIsLoadingAnswers(true);

//         try {
//             const [answersResponse, questionResponse] = await Promise.all([
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
//                 axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
//             ]);
//             setAllSubmittedAnswers(answersResponse.data);
//             setJobQuestions(questionResponse.data || []);
//         } catch (error) {
//             console.error("Error fetching submitted answers or questions:", error);
//             setAllSubmittedAnswers(null);
//             setFilteredSubmittedAnswers(null);
//             setJobQuestions(null);
//         } finally {
//             setIsLoadingAnswers(false);
//         }
//     };

//     useEffect(() => {
//         if (allSubmittedAnswers && currentJobId !== null) {
//             const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
//             setFilteredSubmittedAnswers(filtered || null);
//         } else {
//             setFilteredSubmittedAnswers(null);
//         }
//     }, [allSubmittedAnswers, currentJobId]);

//     return (
//         <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
//             <Modal.Header closeButton>
//                 <Modal.Title className="gradient-text">
//                     {applicant?.first_name || applicant?.email || 'Applicant'} Details
//                 </Modal.Title>
//             </Modal.Header>
//             <Modal.Body className="p-4">
//                 {/* --- Job Applications Section --- */}
//                 <Card className="mb-4 shadow-sm">
//                     <Card.Header className="bg-light">
//                         <h5 className="mb-0">Job Applications</h5>
//                     </Card.Header>
//                     <Card.Body className="p-0">
//                         <Table striped bordered hover responsive size="sm" className="mb-0">
//                             <thead className="table-light">
//                                 <tr>
//                                     <th style={{ width: '40%' }}>Job Title</th>
//                                     <th style={{ width: '40%' }}>Status</th>
//                                     <th style={{ width: '20%' }}>Applied On</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {jobapplications && jobapplications.length > 0 ? (
//                                     jobapplications.map((jobApp) => {
//                                         // Use the globally defined jobStatusOptions
//                                         const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
//                                         return (
//                                             <tr key={jobApp.id}>
//                                                 <td>{jobApp.job_title || 'N/A'}</td>
//                                                 <td>
//                                                     <Form.Select
//                                                         size="sm"
//                                                         className={`${statusOption?.bgColor || 'bg-light'}`}
//                                                         value={jobApp.job_status}
//                                                         onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
//                                                         aria-label={`Job status for ${jobApp.job_title}`}
//                                                         style={{ minWidth: '150px', color: statusOption?.bgColor.includes('text-dark') ? '#000' : '#fff' }} // Updated color logic slightly
//                                                     >
//                                                         {/* Use the globally defined jobStatusOptions */}
//                                                         {jobStatusOptions.map((option) => (
//                                                             <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
//                                                                 {option.label}
//                                                             </option>
//                                                         ))}
//                                                     </Form.Select>
//                                                 </td>
//                                                 <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
//                                             </tr>
//                                         );
//                                     })
//                                 ) : (
//                                     <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
//                                 )}
//                             </tbody>
//                         </Table>
//                     </Card.Body>
//                 </Card>

//                 {/* --- Personality Assessments Section --- */}
//                 <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
//                 <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
//                     {Array.isArray(personalityData) && personalityData.length > 0 ? (
//                         personalityData.map((data, index) => (
//                             data && data.job_id ? (
//                                 <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}>
//                                     <Card.Header className="bg-light">
//                                         <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment for Job ID: ${data.job_id}`}</Card.Title>
//                                     </Card.Header>
//                                     <Card.Body className="d-flex flex-column p-2">
//                                         <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
//                                             <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
//                                         </div>
//                                         <div className="mt-auto">
//                                             <p className="mb-1">
//                                                 <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
//                                             </p>
//                                             <p className="mb-2">
//                                                 <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
//                                             </p>
//                                             <Button
//                                                 variant="outline-info"
//                                                 size="sm"
//                                                 onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
//                                                 disabled={isLoadingAnswers && currentJobId === data.job_id}
//                                             >
//                                                 {isLoadingAnswers && currentJobId === data.job_id ? (
//                                                     <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                                 ) : (
//                                                     <i className="fas fa-receipt me-1"></i>
//                                                 )}
//                                                 View Answers
//                                             </Button>
//                                         </div>
//                                     </Card.Body>
//                                 </Card>
//                             ) : null
//                         ))
//                     ) : (
//                         <p className="text-center text-muted w-100">No personality assessment data available.</p>
//                     )}
//                 </div>

//                 {/* --- Submitted Answers Section (Conditional) --- */}
//                 {currentJobId && (
//                     <div className="mt-4">
//                         <Card className="shadow-sm">
//                             <Card.Header className="bg-light">
//                                 <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
//                             </Card.Header>
//                             <Card.Body>
//                                 {isLoadingAnswers ? (
//                                     <div className="text-center p-4">
//                                         <Spinner animation="border" variant="primary" />
//                                         <p className="mt-2 mb-0">Loading answers...</p>
//                                     </div>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
//                                     <Table striped bordered hover responsive size="sm">
//                                         <thead className="table-light">
//                                             <tr>
//                                                 <th style={{ width: '5%' }}>#</th>
//                                                 <th style={{ width: '45%' }}>Question</th>
//                                                 <th style={{ width: '35%' }}>Your Answer(s)</th>
//                                                 <th style={{ width: '15%' }} className="text-center">Result</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {jobQuestions.map((question, index) => {
//                                                 const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
//                                                     ans => ans.question_id === question.id
//                                                 );

//                                                 let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
//                                                 let resultDisplay = <span className="badge bg-secondary">N/A</span>;
//                                                 let resultText = "Not Answered";

//                                                 const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

//                                                 if (submittedAnswer) {
//                                                     if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
//                                                         const selectedIndex = submittedAnswer.selected_answer_index;
//                                                         const correctIndex = question.correct_answer_index;

//                                                         yourAnswerDisplay = (
//                                                             <ul className="list-unstyled mb-0 small">
//                                                                 {question.answers.map((answerText, ansIndex) => (
//                                                                     <li key={ansIndex}
//                                                                         className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`}
//                                                                         title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')}
//                                                                     >
//                                                                         {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
//                                                                         {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{ fontSize: '0.7em' }}></i>}
//                                                                         {answerText}
//                                                                     </li>
//                                                                 ))}
//                                                             </ul>
//                                                         );

//                                                         if (selectedIndex === correctIndex) {
//                                                             resultDisplay = <span className="badge bg-success">Correct</span>; resultText = "Correct";
//                                                         } else {
//                                                             resultDisplay = <span className="badge bg-danger">Wrong</span>; resultText = "Wrong";
//                                                         }
//                                                     } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
//                                                         yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>;
//                                                         resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; resultText = "Manual Check";
//                                                     }
//                                                 }

//                                                 let rowClass = '';
//                                                 if (resultText === "Correct") rowClass = 'table-success-light';
//                                                 else if (resultText === "Wrong") rowClass = 'table-danger-light';
//                                                 else if (resultText === "Not Answered") rowClass = 'table-warning-light';

//                                                 return (
//                                                     <tr key={question.id || index} className={rowClass}>
//                                                         <td className="text-muted">{index + 1}</td>
//                                                         <td className="small">{question.question_text}</td>
//                                                         <td>{yourAnswerDisplay}</td>
//                                                         <td className="text-center align-middle">{resultDisplay}</td>
//                                                     </tr>
//                                                 );
//                                             })}
//                                         </tbody>
//                                     </Table>
//                                 ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
//                                     <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
//                                 ) : !filteredSubmittedAnswers ? (
//                                     <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
//                                 ) : null}
//                             </Card.Body>
//                         </Card>
//                     </div>
//                 )}
//             </Modal.Body>
//             <Modal.Footer className="bg-light">
//                 <Button variant="secondary" onClick={onHide}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// // --- Utility Functions (Outside Components) ---
// const handleDownloadResume = async (applicantId, resumeFileName) => {
//     if (!applicantId || !resumeFileName) return;
//     try {
//         const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
//             responseType: "arraybuffer",
//         });
//         const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
//         const url = window.URL.createObjectURL(blob);
//         const link = document.createElement("a");
//         link.href = url;
//         const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
//         link.setAttribute("download", safeFileName);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error("Error downloading resume:", error);
//         alert("Failed to download resume. Please check console for details.");
//     }
// };

// // --- Main Component: Jobapplicationresult (Enhanced UI/UX) ---
// export default function Jobapplicationresult() {
//     const [applicationList, setApplicationList] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [successMessage, setSuccessMessage] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");
//     const recordsPerPage = 10;
//     const [jobapplications, setJobApplications] = useState([]); // For the modal
//     const [showModal, setShowModal] = useState(false);
//     const [showDetailsModal, setShowDetailsModal] = useState(false);
//     const [selectedApplicant, setSelectedApplicant] = useState(null); // For ApplicantModal
//     const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null); // For ApplicantDetailsModal
//     const [filterJobTitle, setFilterJobTitle] = useState("");
//     const [filterJobStatus, setFilterJobStatus] = useState(""); // This will hold the value like "applied", "selected" etc.
//     const [filterLocation, setFilterLocation] = useState(""); // City filter
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isDownloadingBank, setIsDownloadingBank] = useState(false);

//     const fetchApplicants = () => {
//         setIsLoading(true);
//         setError(null);
//         axios
//             .get("https://raasbackend.vetrinahealthcare.com/applicants/")
//             .then(async (response) => {
//                 const potentialApplicants = response.data || [];
//                 const results = await Promise.allSettled(
//                     potentialApplicants.map(async (application) => {
//                         if (!application || !application.id) return null;

//                         try {
//                             const jobTitleResponse = await axios.get(
//                                 `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`
//                             );
//                             const jobData = jobTitleResponse.data || [];

//                             if (!jobData || jobData.length === 0) {
//                                 return null; // Filter out users with no job applications
//                             }

//                             const jobTitles = jobData.map((job) => job.job_title).filter(Boolean);
//                             const jobStatuses = jobData.map((job) => job.job_status).filter(Boolean);

//                             return {
//                                 ...application,
//                                 job_titles: jobTitles,
//                                 job_status: jobStatuses, // Store raw status values
//                                 location: application.district || null,
//                             };
//                         } catch (error) {
//                             console.error(`Error processing job details for potential applicant ${application.id}, filtering out:`, error);
//                             return null;
//                         }
//                     })
//                 );

//                 const confirmedApplicants = results
//                     .filter(result => result.status === 'fulfilled' && result.value)
//                     .map(result => result.value);

//                 setApplicationList(confirmedApplicants);
//             })
//             .catch((error) => {
//                 console.error("Error fetching potential applicants list:", error);
//                 setError("Failed to load applicant data. Please try refreshing the page.");
//                 setApplicationList([]);
//             })
//             .finally(() => {
//                 setIsLoading(false);
//             });
//     };

//     useEffect(() => {
//         fetchApplicants();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
//         setJobApplications(prev =>
//             prev.map(app =>
//                 app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
//             )
//         );

//         // Update the main applicationList (more robust approach might be needed depending on data structure)
//         setApplicationList(prevList => prevList.map(applicant => {
//             const relevantJobApp = jobapplications.find(j => j.id === jobApplicationId && applicant.job_titles.includes(j.job_title)); // Find if this applicant had the job
//              if(relevantJobApp) {
//                 // Find the index of the specific job application's status to update
//                  const jobIndex = applicant.job_titles.findIndex(title => title === relevantJobApp.job_title); // Assumes titles are unique per applicant for simplicity here
//                  if (jobIndex !== -1 && applicant.job_status && applicant.job_status.length > jobIndex) {
//                     const newStatuses = [...applicant.job_status];
//                     newStatuses[jobIndex] = newStatus;
//                     return { ...applicant, job_status: newStatuses };
//                  }
//              }
//              return applicant;
//         }));
//          // Alternative: Consider refetching if the above logic is too complex/unreliable
//          // fetchApplicants();
//     };

//     // Memoized filtering logic
//     const filteredApplications = useMemo(() => {
//         return applicationList.filter((application) => {
//             if (!application) return false;

//             const searchQueryLower = searchQuery.toLowerCase();
//             const filterJobTitleLower = filterJobTitle.toLowerCase();
//             // filterJobStatus already holds the value like "applied", "selected"
//             const filterLocationLower = filterLocation.toLowerCase();

//             const matchesSearchQuery = searchQuery
//                 ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
//                     (application.email || '').toLowerCase().includes(searchQueryLower))
//                 : true;

//             const matchesJobTitle = filterJobTitle
//                 ? application.job_titles?.some(title => title?.toLowerCase().includes(filterJobTitleLower))
//                 : true;

//             // Match against the raw status values stored in application.job_status
//             const matchesJobStatus = filterJobStatus
//                 ? application.job_status?.some(status => status === filterJobStatus)
//                 : true;

//             const matchesLocation = filterLocation
//                 ? (application.location || '').toLowerCase().includes(filterLocationLower)
//                 : true;

//             return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
//         });
//     }, [applicationList, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

//     const indexOfLastRecord = currentPage * recordsPerPage;
//     const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//     const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
//     const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber >= 1 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//         }
//     };

//     const handleViewDetails = async (applicant) => {
//         if (!applicant || !applicant.id) return;
//         setSelectedApplicant(applicant);
//         setJobApplications([]);
//         setShowModal(true);

//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
//             setJobApplications(response.data || []);
//         } catch (error) {
//             console.error(`Error fetching job apps for ${applicant.id}:`, error);
//             setJobApplications([]);
//             setError(`Could not load job applications for ${applicant.first_name || applicant.email}.`);
//         }
//     };

//     const handleViewApplicantDetails = async (applicantId) => {
//         if (!applicantId) return;
//         setSelectedApplicantDetails(null);
//         setShowDetailsModal(true);
//         try {
//             const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
//             setSelectedApplicantDetails(response.data);
//         } catch (error) {
//             console.error("Error fetching applicant details:", error);
//             setShowDetailsModal(false);
//             setError("Could not fetch full applicant details.");
//             setSelectedApplicantDetails(null);
//         }
//     };

//     const handleDownloadResumeBank = async () => {
//         setError(null);
//         setIsDownloadingBank(true);
//         try {
//             const response = await axios.get('https://raasbackend.vetrinahealthcare.com/download-resume-bank/', {
//                 responseType: 'blob',
//             });
//             const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', 'applicant_data.xlsx');
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(url);
//         } catch (error) {
//             console.error("Error downloading resume bank:", error);
//             let errorMsg = "Failed to download the Applicant Data file.";
//             if (error.response?.status === 404) {
//                 errorMsg = "Error: Applicant Data file not found on server.";
//             } else if (error.request) {
//                 errorMsg = "Network error: Could not connect to server.";
//             }
//             setError(errorMsg);
//         } finally {
//             setIsDownloadingBank(false);
//         }
//     };

//     // --- Dynamic options for filters (Memoized) ---
//     const uniqueJobTitles = useMemo(() => {
//         const titles = applicationList.flatMap(app => app.job_titles || []);
//         return [...new Set(titles)].sort();
//     }, [applicationList]);

//     // Use the globally defined jobStatusOptions for the filter dropdown
//     const jobStatusOptionsForFilter = useMemo(() => [
//         { value: "", label: "All Statuses" }, // Add the "All" option
//         // Use the global definition
//         ...jobStatusOptions.map(opt => ({ value: opt.value, label: opt.label }))
//     ], []); // No dependency needed as jobStatusOptions is constant

//     const uniqueLocations = useMemo(() => {
//         const locations = applicationList.map(app => app.location).filter(Boolean);
//         return [...new Set(locations)].sort();
//     }, [applicationList]);

//     return (
//         <>
//             <DashNavbar />
//             <div className="wrapper">
//                 <Sidebar />
//                 <main className="main p-3">
//                     <div className="container-fluid">
//                         {/* --- Fixed Alerts --- */}
//                         {successMessage && (
//                             <Alert
//                                 variant="success"
//                                 onClose={() => setSuccessMessage("")}
//                                 dismissible
//                                 className="position-fixed top-0 end-0 m-3 shadow"
//                                 style={{ zIndex: 1056, minWidth: '300px', top: '60px' }}
//                             >
//                                 <i className="fas fa-check-circle me-2"></i>{successMessage}
//                             </Alert>
//                         )}
//                         {error && (
//                             <Alert
//                                 variant="danger"
//                                 onClose={() => setError(null)}
//                                 dismissible
//                                 className="position-fixed top-0 end-0 m-3 shadow"
//                                 style={{ zIndex: 1055, minWidth: '300px', top: successMessage ? '120px' : '60px' }}
//                             >
//                                 <i className="fas fa-exclamation-triangle me-2"></i> {error}
//                             </Alert>
//                         )}

//                         <Card className="shadow-sm mb-4">
//                             <Card.Header className="bg-light d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3">
//                                 <h1 className="h4 gradient-text mb-2 mb-md-0">Applicant Management</h1>
//                                 <Button
//                                     variant="success"
//                                     size="sm"
//                                     onClick={handleDownloadResumeBank}
//                                     disabled={isDownloadingBank || isLoading}
//                                 >
//                                     {isDownloadingBank ? (
//                                         <>
//                                             <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
//                                             <span className="visually-hidden">Loading...</span> Downloading...
//                                         </>
//                                     ) : (
//                                         <><i className="fas fa-file-excel me-2"></i> Download Applicant Data (XLSX)</>
//                                     )}
//                                 </Button>
//                             </Card.Header>
//                             <Card.Body className="p-3">
//                                 {/* --- Search and Filters Row --- */}
//                                 <div className="row g-2 mb-3 align-items-center">
//                                     <div className="col-md-3">
//                                         <InputGroup size="sm">
//                                             <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
//                                             <Form.Control
//                                                 type="search"
//                                                 placeholder="Search Name or Email..."
//                                                 value={searchQuery}
//                                                 onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
//                                                 aria-label="Search Applicants"
//                                             />
//                                         </InputGroup>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Title">
//                                             <option value="">All Job Titles</option>
//                                             {uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                          {/* Use the generated options for the filter */}
//                                         <Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }} aria-label="Filter by Job Status">
//                                             {jobStatusOptionsForFilter.map((option) => (
//                                                 <option key={option.value} value={option.value}>{option.label}</option>
//                                             ))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-2 col-6">
//                                         <Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }} aria-label="Filter by Location (City)">
//                                             <option value="">All Locations</option>
//                                             {uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}
//                                         </Form.Select>
//                                     </div>
//                                     <div className="col-md-3 col-6 text-md-end">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
//                                             <i className="fas fa-undo me-1"></i> Reset Filters
//                                         </Button>
//                                     </div>
//                                 </div>

//                                 {/* --- Table Section --- */}
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover size="sm" className="align-middle">
//                                         <thead className="table-dark">
//                                             <tr>
//                                                 <th>First Name</th>
//                                                 <th>Middle Name</th>
//                                                 <th>Last Name</th>
//                                                 <th>Email</th>
//                                                 <th>Phone</th>
//                                                 <th>Location</th>
//                                                 <th className="text-center">Resume</th>
//                                                 <th className="text-center" style={{ minWidth: '100px' }}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {isLoading ? (
//                                                 <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0">Loading Applicants...</p></td></tr>
//                                             ) : currentRecords.length > 0 ? (
//                                                 currentRecords.map((application) => (
//                                                     <tr key={application.id}>
//                                                         <td>{application.first_name || '-'}</td>
//                                                         <td>{application.middle_name || ''}</td>
//                                                         <td>{application.last_name || '-'}</td>
//                                                         <td>{application.email || '-'}</td>
//                                                         <td>{application.phone || '-'}</td>
//                                                         <td>{application.location || '-'}</td>
//                                                         <td className="text-center">
//                                                             {application.resume ? (
//                                                                 <Button variant="outline-primary" size="sm" className="p-1" onClick={() => handleDownloadResume(application.id, application.resume)} title={`Download ${application.resume}`}>
//                                                                     <i className="fas fa-download fa-fw"></i>
//                                                                 </Button>
//                                                             ) : (<span className="text-muted small">N/A</span>)}
//                                                         </td>
//                                                         <td className="text-center">
//                                                             <Button variant="info" size="sm" className="me-2 p-2 mb-1" onClick={() => handleViewDetails(application)} title="Check Results & Status">
//                                                                 <i className="fas fa-clipboard-check fa-fw"></i>
//                                                             </Button>
//                                                             <Button variant="secondary" size="sm" className="p-2" onClick={() => handleViewApplicantDetails(application.id)} title="View Full Applicant Details">
//                                                                 <i className="fas fa-user fa-fw"></i>
//                                                             </Button>
//                                                         </td>
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr><td colSpan="8" className="text-center text-muted p-4">{applicationList.length === 0 && !isLoading ? "No applicants found." : "No applicants match the current filters."}</td></tr>
//                                             )}
//                                         </tbody>
//                                     </Table>
//                                 </div>

//                                 {/* --- Pagination --- */}
//                                 {totalPages > 1 && !isLoading && (
//                                     <div className="d-flex justify-content-center mt-3 flex-wrap">
//                                         <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="me-1 mb-1"> « Prev </Button>
//                                         {[...Array(totalPages).keys()].map((page) => (
//                                             <Button key={page + 1} variant={currentPage === page + 1 ? "primary" : "outline-primary"} size="sm" className="mx-1 mb-1" onClick={() => handlePageChange(page + 1)}> {page + 1} </Button>
//                                         ))}
//                                         <Button variant="outline-secondary" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="ms-1 mb-1"> Next » </Button>
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     </div>

//                     {/* --- Modals --- */}
//                     {showModal && selectedApplicant && (
//                         <ApplicantModal
//                             applicant={selectedApplicant}
//                             jobapplications={jobapplications}
//                             setSuccessMessage={setSuccessMessage}
//                             updateJobApplication={updateJobApplicationStatusInList}
//                             key={`modal-${selectedApplicant.id}-${jobapplications.length}`}
//                         />
//                     )}

//                     {showDetailsModal && (
//                         <ApplicantDetailsModal
//                             show={showDetailsModal}
//                             onHide={() => setShowDetailsModal(false)}
//                             applicant={selectedApplicantDetails}
//                             isLoading={!selectedApplicantDetails && showDetailsModal}
//                         />
//                     )}

//                 </main>
//             </div>
//         </>
//     );
// }


import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/dash.css"; // Make sure this path is correct
import Sidebar from "./Sidebar"; // Make sure this path is correct
import DashNavbar from "./DashNavbar"; // Make sure this path is correct
import { Table, Alert, Modal, Button, Card, Spinner, InputGroup, Form, Pagination } from "react-bootstrap";
import Chart from "chart.js/auto";
import ApplicantDetailsModal from "../ProfileForm/ApplicantDetailsModal";

const CustomStyles = () => (
  <style>{`
    .exam-result-page .card { flex: 1; display: flex; flex-direction: column; overflow: hidden; border: none; border-radius: 12px; box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); margin-bottom: 0 !important; }
    .exam-result-page .card-body { flex: 1; overflow-y: auto; display: flex; flex-direction: column; padding: 0 !important; }
    .exam-result-page .table-container { flex: 1; overflow-y: auto; padding: 0 1.5rem; }
    .exam-result-page .card-header { background: white; border-bottom: 1px solid #edf2f7; padding: 0.75rem 1.5rem; }
    .exam-result-page .card-footer { background: white; border-top: 1px solid #edf2f7; padding: 0.75rem 1.5rem; }
    
    /* Compact Table Styling */
    .exam-result-page .table td { padding: 8px 12px !important; font-size: 14px; }
    .exam-result-page .table th { padding: 12px !important; font-size: 13px; text-transform: uppercase; letter-spacing: 0.5px; }
    .exam-result-page .filters-container { padding: 1rem 1.5rem; flex-shrink: 0; background-color: #fcfcfc; border-bottom: 1px solid #f0f0f0; }
  `}</style>
);

// --- Define Job Status Options Globally ---
const jobStatusOptions = [
    { value: "applied", label: "Applied", bgColor: "bg-info" },
    { value: "under_review", label: "Under Review", bgColor: "bg-secondary" },
    { value: "interview_scheduled", label: "Interview Scheduled", bgColor: "bg-warning text-dark" }, // Added text-dark
    { value: "selected", label: "Selected", bgColor: "bg-success" },
    { value: "rejected", label: "Rejected", bgColor: "bg-danger" },
];

// --- ApplicantModal Component (Enhanced UI/UX) ---
const ApplicantModal = ({
    applicant,
    jobapplications,
    setSuccessMessage,
    updateJobApplication,
}) => {
    // jobStatusOptions is now defined outside, no need to redefine here

    const [show, setShow] = useState(false);
    const [personalityData, setPersonalityData] = useState([]);
    const [personalityJobTitles, setPersonalityJobTitles] = useState([]);
    const chartRefs = useRef({});
    const [allSubmittedAnswers, setAllSubmittedAnswers] = useState(null);
    const [filteredSubmittedAnswers, setFilteredSubmittedAnswers] = useState(null);
    const [currentJobId, setCurrentJobId] = useState(null);
    const [jobQuestions, setJobQuestions] = useState(null);
    const [isLoadingAnswers, setIsLoadingAnswers] = useState(false);

    const handleStatusChange = (id, newStatus) => {
        axios
            .put(`https://raasbackend.vetrinahealthcare.com/applicants/update_status/${id}/`, { job_status: newStatus })
            .then(() => {
                setSuccessMessage("Job status updated successfully");
                updateJobApplication(id, newStatus);
                setTimeout(() => setSuccessMessage(""), 5000);
            })
            .catch((error) => {
                console.error("Error updating job status:", error);
                // Consider showing an error alert here
            });
    };

    useEffect(() => {
        setShow(false);
        const timer = setTimeout(() => {
            if (applicant && jobapplications) {
                setShow(true);
            }
        }, 100);

        return () => {
            clearTimeout(timer);
            setPersonalityData([]);
            setPersonalityJobTitles([]);
            setAllSubmittedAnswers(null);
            setFilteredSubmittedAnswers(null);
            setJobQuestions(null);
            setCurrentJobId(null);
            Object.values(chartRefs.current).forEach(chart => chart?.destroy());
            chartRefs.current = {};
        };
    }, [applicant, jobapplications]);

    useEffect(() => {
        // We trigger the data fetch only when the modal is shown and we have the necessary data
        if (show && applicant?.id && Array.isArray(jobapplications)) {
            fetchPersonalityData(applicant.id, jobapplications);
        }
    }, [show, applicant, jobapplications]);

    // ========================================================================
    // --- MODIFIED FUNCTION TO FIX THE FILTERING LOGIC ---
    // This function now correctly filters personality results to show only
    // those for jobs the candidate has actually applied to.
    // ========================================================================
    const fetchPersonalityData = async (applicantId, applications) => {
        // If there are no job applications for this user, we don't need to fetch anything.
        if (!applications || applications.length === 0) {
            setPersonalityData([]);
            setPersonalityJobTitles([]);
            return;
        }

        try {
            // 1. Create a Set of applied-for job IDs for efficient lookup.
            // Using Number() makes the check robust against string/number type mismatches.
            const appliedJobIds = new Set(applications.map(app => Number(app.job_id)));

            // 2. Fetch ALL personality assessment results for the given applicant.
            const personalityUrl = `https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`;
            const personalityResponse = await axios.get(personalityUrl);
            const allPersonalityResults = personalityResponse.data || [];

            // 3. Filter the full list of results. Keep only the results where the job_id
            // is present in our set of applied-for job IDs.
            const filteredResults = allPersonalityResults.filter(
                result => result && appliedJobIds.has(Number(result.job_id))
            );
            
            setPersonalityData(filteredResults);

            // 4. Create a map of job titles from the applications for easy access.
            if (filteredResults.length > 0) {
                const jobTitlesMap = applications.reduce((acc, app) => {
                    if (app.job_id) {
                        acc[app.job_id] = app.job_title;
                    }
                    return acc;
                }, {});
                
                // Map the filtered results to their corresponding job titles.
                const jobTitles = filteredResults.map(data => jobTitlesMap[data.job_id] || `Job ID: ${data.job_id}`);
                setPersonalityJobTitles(jobTitles);
            } else {
                setPersonalityJobTitles([]);
            }

        } catch (error) {
            console.error("Error fetching or filtering personality assessment data:", error);
            setPersonalityData([]);
            setPersonalityJobTitles([]);
        }
    };
    // --- END OF MODIFIED FUNCTION ---

    useEffect(() => {
        Object.values(chartRefs.current).forEach(chart => chart?.destroy());
        chartRefs.current = {};

        if (Array.isArray(personalityData)) {
            personalityData.forEach((data, index) => {
                const chartId = `personalityChart-${applicant?.id}-${index}`;
                const chartElement = document.getElementById(chartId);
                if (chartElement && data && data.job_id) {
                    try {
                        const newChart = createDonutChart(data, chartId, data.status);
                        if (newChart) {
                            chartRefs.current[index] = newChart;
                        }
                    } catch (chartError) {
                        console.error("Error creating chart:", chartError, "for data:", data);
                    }
                }
            });
        }
    }, [personalityData, applicant?.id]);

    const onHide = () => {
        setShow(false);
    };

    const createDonutChart = (data, chartId, status) => {
        if (!data || typeof data.correct_count !== 'number' || typeof data.all_count !== 'number' || typeof data.wrong_count !== 'number' || data.all_count === 0) {
            console.warn(`Invalid chart data for ${chartId}`, data);
            const ctx = document.getElementById(chartId)?.getContext("2d");
            if (ctx) {
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
                ctx.font = "12px Arial";
                ctx.textAlign = "center";
                ctx.fillText("Data unavailable", ctx.canvas.width / 2, ctx.canvas.height / 2);
            }
            return null;
        }
        const { correct_count, wrong_count } = data;
        const ctx = document.getElementById(chartId)?.getContext("2d");

        if (!ctx) {
            console.error(`Canvas element with id ${chartId} not found`);
            return null;
        }

        return new Chart(ctx, {
            type: 'doughnut',
            data: {
                labels: [`Correct (${correct_count})`, `Wrong (${wrong_count})`],
                datasets: [{
                    data: [correct_count, wrong_count],
                    backgroundColor: ['rgba(40, 167, 69, 0.7)', 'rgba(220, 53, 69, 0.7)'],
                    borderColor: ['rgba(40, 167, 69, 1)', 'rgba(220, 53, 69, 1)'],
                    borderWidth: 1,
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: '60%',
                plugins: {
                    legend: { display: true, position: 'bottom', labels: { boxWidth: 10, padding: 15, font: { size: 10 } } },
                    title: { display: false },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                let label = context.label || '';
                                if (label) { label += ': '; }
                                const value = context.parsed;
                                const total = context.dataset.data.reduce((a, b) => a + b, 0);
                                const percentage = total > 0 ? ((value / total) * 100).toFixed(1) + '%' : '0%';
                                label += `${value} (${percentage})`;
                                return label;
                            }
                        }
                    }
                }
            }
        });
    };

    const handleShowSubmittedAnswers = async (applicantId, jobId) => {
        setCurrentJobId(jobId);
        setFilteredSubmittedAnswers(null);
        setJobQuestions(null);
        setAllSubmittedAnswers(null);
        setIsLoadingAnswers(true);

        try {
            const [answersResponse, questionResponse] = await Promise.all([
                axios.get(`https://raasbackend.vetrinahealthcare.com/get_personality_results/${applicantId}/`),
                axios.get(`https://raasbackend.vetrinahealthcare.com/questions/${jobId}/`)
            ]);
            setAllSubmittedAnswers(answersResponse.data);
            setJobQuestions(questionResponse.data || []);
        } catch (error) {
            console.error("Error fetching submitted answers or questions:", error);
            setAllSubmittedAnswers(null);
            setFilteredSubmittedAnswers(null);
            setJobQuestions(null);
        } finally {
            setIsLoadingAnswers(false);
        }
    };

    useEffect(() => {
        if (allSubmittedAnswers && currentJobId !== null) {
            const filtered = allSubmittedAnswers.find(item => item.job_id === currentJobId);
            setFilteredSubmittedAnswers(filtered || null);
        } else {
            setFilteredSubmittedAnswers(null);
        }
    }, [allSubmittedAnswers, currentJobId]);

    return (
        <Modal show={show} onHide={onHide} dialogClassName="modal-xl" centered scrollable>
            <Modal.Header closeButton>
                <Modal.Title className="gradient-text">
                    {applicant?.first_name || applicant?.email || 'Applicant'} Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                {/* --- Job Applications Section --- */}
                <Card className="mb-4 shadow-sm">
                    <Card.Header className="bg-light">
                        <h5 className="mb-0">Job Applications</h5>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Table striped bordered hover responsive size="sm" className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th style={{ width: '40%' }}>Job Title</th>
                                    <th style={{ width: '40%' }}>Status</th>
                                    <th style={{ width: '20%' }}>Applied On</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobapplications && jobapplications.length > 0 ? (
                                    jobapplications.map((jobApp) => {
                                        const statusOption = jobStatusOptions.find(opt => opt.value === jobApp.job_status);
                                        return (
                                            <tr key={jobApp.id}>
                                                <td>{jobApp.job_title || 'N/A'}</td>
                                                <td>
                                                    <Form.Select
                                                        size="sm"
                                                        className={`${statusOption?.bgColor || 'bg-light'}`}
                                                        value={jobApp.job_status}
                                                        onChange={(e) => handleStatusChange(jobApp.id, e.target.value)}
                                                        aria-label={`Job status for ${jobApp.job_title}`}
                                                        style={{ minWidth: '150px', color: statusOption?.bgColor.includes('text-dark') ? '#000' : '#fff' }}
                                                    >
                                                        {jobStatusOptions.map((option) => (
                                                            <option key={option.value} value={option.value} style={{ backgroundColor: '#fff', color: '#000' }}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </td>
                                                <td>{jobApp.applied_date ? new Date(jobApp.applied_date).toLocaleDateString() : 'N/A'}</td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr><td colSpan="3" className="text-center text-muted p-3">No job applications found.</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>

                {/* --- Personality Assessments Section --- */}
                <h4 className="gradient-text text-center mt-4 mb-3">Personality Assessments</h4>
                <div className="d-flex flex-wrap justify-content-center align-items-stretch gap-3">
                    {Array.isArray(personalityData) && personalityData.length > 0 ? (
                        personalityData.map((data, index) => (
                            data && data.job_id ? (
                                <Card key={`${data.job_id}-${index}`} className="text-center shadow-sm" style={{ minWidth: '260px', maxWidth: '300px', flex: '1 1 260px' }}>
                                    <Card.Header className="bg-light">
                                        <Card.Title as="h6" className="mb-0 text-truncate">{personalityJobTitles[index] || `Assessment for Job ID: ${data.job_id}`}</Card.Title>
                                    </Card.Header>
                                    <Card.Body className="d-flex flex-column p-2">
                                        <div style={{ height: '150px', width: '100%', margin: '0 auto 10px auto' }}>
                                            <canvas id={`personalityChart-${applicant?.id}-${index}`}></canvas>
                                        </div>
                                        <div className="mt-auto">
                                            <p className="mb-1">
                                                <strong>Score:</strong> <b className="gradient-text">{typeof data.status === 'number' ? `${data.status.toFixed(1)}%` : 'N/A'}</b>
                                            </p>
                                            <p className="mb-2">
                                                <strong>Result:</strong> {data.result === 'T' ? <span className="badge bg-success">Passed</span> : <span className="badge bg-danger">Failed</span>}
                                            </p>
                                            <Button
                                                variant="outline-info"
                                                size="sm"
                                                onClick={() => handleShowSubmittedAnswers(applicant.id, data.job_id)}
                                                disabled={isLoadingAnswers && currentJobId === data.job_id}
                                            >
                                                {isLoadingAnswers && currentJobId === data.job_id ? (
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                ) : (
                                                    <i className="fas fa-receipt me-1"></i>
                                                )}
                                                View Answers
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ) : null
                        ))
                    ) : (
                        <p className="text-center text-muted w-100">No personality assessment data found for the jobs this candidate applied to.</p>
                    )}
                </div>

                {/* --- Submitted Answers Section (Conditional) --- */}
                {currentJobId && (
                    <div className="mt-4">
                        <Card className="shadow-sm">
                            <Card.Header className="bg-light">
                                <h5 className="mb-0">Submitted Answers for Job: {personalityJobTitles[personalityData.findIndex(p => p.job_id === currentJobId)] || `ID ${currentJobId}`}</h5>
                            </Card.Header>
                            <Card.Body>
                                {isLoadingAnswers ? (
                                    <div className="text-center p-4">
                                        <Spinner animation="border" variant="primary" />
                                        <p className="mt-2 mb-0">Loading answers...</p>
                                    </div>
                                ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length > 0 ? (
                                    <Table striped bordered hover responsive size="sm">
                                        <thead className="table-light">
                                            <tr>
                                                <th style={{ width: '5%' }}>#</th>
                                                <th style={{ width: '45%' }}>Question</th>
                                                <th style={{ width: '35%' }}>Your Answer(s)</th>
                                                <th style={{ width: '15%' }} className="text-center">Result</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {jobQuestions.map((question, index) => {
                                                const submittedAnswer = filteredSubmittedAnswers.selected_answers?.find(
                                                    ans => ans.question_id === question.id
                                                );

                                                let yourAnswerDisplay = <i className="text-muted">Not Answered</i>;
                                                let resultDisplay = <span className="badge bg-secondary">N/A</span>;
                                                let resultText = "Not Answered";

                                                const isMultipleChoice = question.answers && question.answers.length > 0 && question.correct_answer_index !== null && question.correct_answer_index !== undefined;

                                                if (submittedAnswer) {
                                                    if (isMultipleChoice && submittedAnswer.selected_answer_index !== null && submittedAnswer.selected_answer_index !== undefined) {
                                                        const selectedIndex = submittedAnswer.selected_answer_index;
                                                        const correctIndex = question.correct_answer_index;

                                                        yourAnswerDisplay = (
                                                            <ul className="list-unstyled mb-0 small">
                                                                {question.answers.map((answerText, ansIndex) => (
                                                                    <li key={ansIndex}
                                                                        className={`${selectedIndex === ansIndex ? 'fw-bold' : ''} ${correctIndex === ansIndex ? 'text-success' : (selectedIndex === ansIndex && selectedIndex !== correctIndex ? 'text-danger' : '')}`}
                                                                        title={correctIndex === ansIndex ? 'Correct Answer' : (selectedIndex === ansIndex ? 'Selected Answer' : '')}
                                                                    >
                                                                        {selectedIndex === ansIndex && <i className="fas fa-check text-primary me-1"></i>}
                                                                        {correctIndex === ansIndex && <i className="fas fa-star text-success me-1" style={{ fontSize: '0.7em' }}></i>}
                                                                        {answerText}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        );

                                                        if (selectedIndex === correctIndex) {
                                                            resultDisplay = <span className="badge bg-success">Correct</span>; resultText = "Correct";
                                                        } else {
                                                            resultDisplay = <span className="badge bg-danger">Wrong</span>; resultText = "Wrong";
                                                        }
                                                    } else if (submittedAnswer.selected_answer_text !== null && submittedAnswer.selected_answer_text !== undefined) {
                                                        yourAnswerDisplay = <span className="fst-italic">{submittedAnswer.selected_answer_text}</span>;
                                                        resultDisplay = <span className="badge bg-info text-dark">Manual Check</span>; resultText = "Manual Check";
                                                    }
                                                }

                                                let rowClass = '';
                                                if (resultText === "Correct") rowClass = 'table-success-light';
                                                else if (resultText === "Wrong") rowClass = 'table-danger-light';
                                                else if (resultText === "Not Answered") rowClass = 'table-warning-light';

                                                return (
                                                    <tr key={question.id || index} className={rowClass}>
                                                        <td className="text-muted">{index + 1}</td>
                                                        <td className="small">{question.question_text}</td>
                                                        <td>{yourAnswerDisplay}</td>
                                                        <td className="text-center align-middle">{resultDisplay}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                ) : filteredSubmittedAnswers && jobQuestions && jobQuestions.length === 0 ? (
                                    <p className="text-center text-muted p-3">No questions were found for this assessment.</p>
                                ) : !filteredSubmittedAnswers ? (
                                    <p className="text-center text-muted p-3">Could not load answers for this assessment.</p>
                                ) : null}
                            </Card.Body>
                        </Card>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

// --- Utility Functions (Outside Components) ---
const handleDownloadResume = async (applicantId, resumeFileName) => {
    if (!applicantId || !resumeFileName) return;
    try {
        const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/api/resume/${applicantId}/`, {
            responseType: "arraybuffer",
        });
        const blob = new Blob([response.data], { type: response.headers['content-type'] || "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        const safeFileName = resumeFileName.replace(/[^a-zA-Z0-9._-]/g, '_');
        link.setAttribute("download", safeFileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Error downloading resume:", error);
        alert("Failed to download resume. Please check console for details.");
    }
};

// --- Main Component: Jobapplicationresult (Enhanced UI/UX) ---
export default function Jobapplicationresult() {
    const [applicationList, setApplicationList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [successMessage, setSuccessMessage] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [jobapplications, setJobApplications] = useState([]); // For the modal
    const [showModal, setShowModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedApplicant, setSelectedApplicant] = useState(null); // For ApplicantModal
    const [selectedApplicantDetails, setSelectedApplicantDetails] = useState(null); // For ApplicantDetailsModal
    const [filterJobTitle, setFilterJobTitle] = useState("");
    const [filterJobStatus, setFilterJobStatus] = useState(""); // This will hold the value like "applied", "selected" etc.
    const [filterLocation, setFilterLocation] = useState(""); // City filter
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isDownloadingBank, setIsDownloadingBank] = useState(false);

    const fetchApplicants = () => {
        setIsLoading(true);
        setError(null);
        axios
            .get("https://raasbackend.vetrinahealthcare.com/api/applicants/")
            .then(async (response) => {
                const potentialApplicants = response.data || [];
                const results = await Promise.allSettled(
                    potentialApplicants.map(async (application) => {
                        if (!application || !application.id) return null;

                        try {
                            const jobTitleResponse = await axios.get(
                                `https://raasbackend.vetrinahealthcare.com/applicant/job-title/${application.id}/`
                            );
                            const jobData = jobTitleResponse.data || [];

                            if (!jobData || jobData.length === 0) {
                                return null; // Filter out users with no job applications
                            }

                            const jobTitles = jobData.map((job) => job.job_title).filter(Boolean);
                            const jobStatuses = jobData.map((job) => job.job_status).filter(Boolean);

                            return {
                                ...application,
                                job_titles: jobTitles,
                                job_status: jobStatuses, // Store raw status values
                                location: application.district || null,
                            };
                        } catch (error) {
                            console.error(`Error processing job details for potential applicant ${application.id}, filtering out:`, error);
                            return null;
                        }
                    })
                );

                const confirmedApplicants = results
                    .filter(result => result.status === 'fulfilled' && result.value)
                    .map(result => result.value);

                setApplicationList(confirmedApplicants);
            })
            .catch((error) => {
                console.error("Error fetching potential applicants list:", error);
                setError("Failed to load applicant data. Please try refreshing the page.");
                setApplicationList([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchApplicants();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateJobApplicationStatusInList = (jobApplicationId, newStatus) => {
        setJobApplications(prev =>
            prev.map(app =>
                app.id === jobApplicationId ? { ...app, job_status: newStatus } : app
            )
        );

        // Update the main applicationList (more robust approach might be needed depending on data structure)
        setApplicationList(prevList => prevList.map(applicant => {
            const relevantJobApp = jobapplications.find(j => j.id === jobApplicationId && applicant.job_titles.includes(j.job_title)); // Find if this applicant had the job
             if(relevantJobApp) {
                // Find the index of the specific job application's status to update
                 const jobIndex = applicant.job_titles.findIndex(title => title === relevantJobApp.job_title); // Assumes titles are unique per applicant for simplicity here
                 if (jobIndex !== -1 && applicant.job_status && applicant.job_status.length > jobIndex) {
                    const newStatuses = [...applicant.job_status];
                    newStatuses[jobIndex] = newStatus;
                    return { ...applicant, job_status: newStatuses };
                 }
             }
             return applicant;
        }));
         // Alternative: Consider refetching if the above logic is too complex/unreliable
         // fetchApplicants();
    };

    // Memoized filtering logic
    const filteredApplications = useMemo(() => {
        return applicationList.filter((application) => {
            if (!application) return false;

            const searchQueryLower = searchQuery.toLowerCase();
            const filterJobTitleLower = filterJobTitle.toLowerCase();
            const filterLocationLower = filterLocation.toLowerCase();

            const matchesSearchQuery = searchQuery
                ? ((application.first_name || '').toLowerCase().includes(searchQueryLower) ||
                    (application.middle_name || '').toLowerCase().includes(searchQueryLower) ||
                    (application.last_name || '').toLowerCase().includes(searchQueryLower) ||
                    (application.email || '').toLowerCase().includes(searchQueryLower))
                : true;

            const matchesJobTitle = filterJobTitle
                ? application.job_titles?.some(title => title?.toLowerCase().includes(filterJobTitleLower))
                : true;

            const matchesJobStatus = filterJobStatus
                ? application.job_status?.some(status => status === filterJobStatus)
                : true;

            const matchesLocation = filterLocation
                ? (application.location || '').toLowerCase().includes(filterLocationLower)
                : true;

            return matchesSearchQuery && matchesJobTitle && matchesJobStatus && matchesLocation;
        });
    }, [applicationList, searchQuery, filterJobTitle, filterJobStatus, filterLocation]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredApplications.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredApplications.length / recordsPerPage);

    const handlePageChange = (pageNumber) => {
        const totalRows = filteredApplications.length;
        const totalPagesCount = Math.ceil(totalRows / recordsPerPage);
        if (pageNumber >= 1 && pageNumber <= totalPagesCount) {
            setCurrentPage(pageNumber);
        }
    };

    const getPageOptions = () => [5, 10, 25, 50, 100];

    const renderPaginationFooter = () => {
        if (isLoading || applicationList.length === 0) return null;
        
        const totalItems = filteredApplications.length;
        const totalPagesCount = Math.ceil(totalItems / recordsPerPage);
        const startRecord = totalItems === 0 ? 0 : (currentPage - 1) * recordsPerPage + 1;
        const endRecord = Math.min(currentPage * recordsPerPage, totalItems);

        return (
            <div className="card-footer d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="text-muted small">
                    Showing <b>{startRecord}</b> to <b>{endRecord}</b> of <b>{totalItems}</b> records
                </div>
                
                <div className="d-flex align-items-center gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span className="text-muted small">Rows per page:</span>
                        <Form.Select 
                            size="sm" 
                            value={recordsPerPage} 
                            onChange={(e) => {
                                setRecordsPerPage(Number(e.target.value));
                                setCurrentPage(1);
                            }}
                            style={{ width: "70px" }}
                        >
                            {getPageOptions().map(opt => <option key={opt} value={opt}>{opt}</option>)}
                        </Form.Select>
                    </div>

                    <Pagination size="sm" className="mb-0">
                        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                        <Pagination.Item active>{currentPage}</Pagination.Item>
                        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPagesCount || totalPagesCount === 0} />
                        <Pagination.Last onClick={() => handlePageChange(totalPagesCount)} disabled={currentPage === totalPagesCount || totalPagesCount === 0} />
                    </Pagination>
                </div>
            </div>
        );
    };

    const handleViewDetails = async (applicant) => {
        if (!applicant || !applicant.id) return;
        setSelectedApplicant(applicant);
        setJobApplications([]);
        setShowModal(true);

        try {
            const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicant/job-title/${applicant.id}/`);
            setJobApplications(response.data || []);
        } catch (error) {
            console.error(`Error fetching job apps for ${applicant.id}:`, error);
            setJobApplications([]);
            setError(`Could not load job applications for ${applicant.first_name || applicant.email}.`);
        }
    };

    const handleViewApplicantDetails = async (applicantId) => {
        if (!applicantId) return;
        setSelectedApplicantDetails(null);
        setShowDetailsModal(true);
        try {
            const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/applicants/${applicantId}/`);
            setSelectedApplicantDetails(response.data);
        } catch (error) {
            console.error("Error fetching applicant details:", error);
            setShowDetailsModal(false);
            setError("Could not fetch full applicant details.");
            setSelectedApplicantDetails(null);
        }
    };

    const handleDownloadResumeBank = async () => {
        setError(null);
        setIsDownloadingBank(true);
        try {
            const response = await axios.get('https://raasbackend.vetrinahealthcare.com/download-resume-bank/', {
                responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'applicant_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading resume bank:", error);
            let errorMsg = "Failed to download the Applicant Data file.";
            if (error.response?.status === 404) {
                errorMsg = "Error: Applicant Data file not found on server.";
            } else if (error.request) {
                errorMsg = "Network error: Could not connect to server.";
            }
            setError(errorMsg);
        } finally {
            setIsDownloadingBank(false);
        }
    };

    // --- Dynamic options for filters (Memoized) ---
    const uniqueJobTitles = useMemo(() => {
        const titles = applicationList.flatMap(app => app.job_titles || []);
        return [...new Set(titles)].sort();
    }, [applicationList]);

    const jobStatusOptionsForFilter = useMemo(() => [
        { value: "", label: "All Statuses" },
        ...jobStatusOptions.map(opt => ({ value: opt.value, label: opt.label }))
    ], []);

    const uniqueLocations = useMemo(() => {
        const locations = applicationList.map(app => app.location).filter(Boolean);
        return [...new Set(locations)].sort();
    }, [applicationList]);

    return (
        <>
            <DashNavbar />
            <div className="exam-result-page wrapper">
                <Sidebar />
                <main className="main">
                    <CustomStyles />
                    <div className="container-fluid flex-grow-1 d-flex flex-column p-3 p-md-4">
                        {/* --- Fixed Alerts --- */}
                        {successMessage && (
                            <Alert
                                variant="success"
                                onClose={() => setSuccessMessage("")}
                                dismissible
                                className="position-fixed top-0 end-0 m-3 shadow"
                                style={{ zIndex: 1056, minWidth: '300px', top: '60px' }}
                            >
                                <i className="fas fa-check-circle me-2"></i>{successMessage}
                            </Alert>
                        )}
                        {error && (
                            <Alert
                                variant="danger"
                                onClose={() => setError(null)}
                                dismissible
                                className="position-fixed top-0 end-0 m-3 shadow"
                                style={{ zIndex: 1055, minWidth: '300px', top: successMessage ? '120px' : '60px' }}
                            >
                                <i className="fas fa-exclamation-triangle me-2"></i> {error}
                            </Alert>
                        )}

                        <Card className="shadow-sm">
                            <Card.Header className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                <h3 className="mb-0 gradient-text">Applicant Management</h3>
                                <Button
                                    variant="success"
                                    size="sm"
                                    onClick={handleDownloadResumeBank}
                                    disabled={isDownloadingBank || isLoading}
                                >
                                    {isDownloadingBank ? (
                                        <>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                            <span className="visually-hidden">Loading...</span> Downloading...
                                        </>
                                    ) : (
                                        <><i className="fas fa-file-excel me-2"></i> Download Data (XLSX)</>
                                    )}
                                </Button>
                            </Card.Header>

                            <Card.Body>
                                <div className="filters-container">
                                    <div className="row g-2 align-items-center">
                                        <div className="col-md-3">
                                            <InputGroup size="sm">
                                                <InputGroup.Text className="bg-light"><i className="fas fa-search text-muted"></i></InputGroup.Text>
                                                <Form.Control
                                                    type="search"
                                                    placeholder="Search name or email..."
                                                    value={searchQuery}
                                                    onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                                                />
                                            </InputGroup>
                                        </div>
                                        <div className="col-md-2 col-6">
                                            <Form.Select size="sm" value={filterJobTitle} onChange={(e) => { setFilterJobTitle(e.target.value); setCurrentPage(1); }}>
                                                <option value="">All Job Titles</option>
                                                {uniqueJobTitles.map((title) => (<option key={title} value={title}>{title}</option>))}
                                            </Form.Select>
                                        </div>
                                        <div className="col-md-2 col-6">
                                            <Form.Select size="sm" value={filterJobStatus} onChange={(e) => { setFilterJobStatus(e.target.value); setCurrentPage(1); }}>
                                                {jobStatusOptionsForFilter.map((option) => (
                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                ))}
                                            </Form.Select>
                                        </div>
                                        <div className="col-md-2 col-6">
                                            <Form.Select size="sm" value={filterLocation} onChange={(e) => { setFilterLocation(e.target.value); setCurrentPage(1); }}>
                                                <option value="">All Locations</option>
                                                {uniqueLocations.map((loc) => (<option key={loc} value={loc}>{loc}</option>))}
                                            </Form.Select>
                                        </div>
                                        <div className="col-md-3 col-6 text-md-end">
                                            <Button variant="outline-secondary" size="sm" className="text-nowrap" onClick={() => { setSearchQuery(''); setFilterJobTitle(''); setFilterJobStatus(''); setFilterLocation(''); setCurrentPage(1); }}>
                                                <i className="fas fa-undo me-1 small"></i> Reset
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-container">
                                    <Table hover className="align-middle mb-0">
                                        <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                                            <tr>
                                                <th>First Name</th>
                                                <th>Middle Name</th>
                                                <th>Last Name</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Location</th>
                                                <th className="text-center">Resume</th>
                                                <th className="text-center" style={{ minWidth: '100px' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                <tr><td colSpan="8" className="text-center p-5"><Spinner animation="border" variant="primary" /><p className="mt-2 mb-0 text-muted">Loading Applicants...</p></td></tr>
                                            ) : currentRecords.length > 0 ? (
                                                currentRecords.map((application) => (
                                                    <tr key={application.id}>
                                                        <td className="fw-bold">{application.first_name || '-'}</td>
                                                        <td>{application.middle_name || ''}</td>
                                                        <td>{application.last_name || '-'}</td>
                                                        <td className="small">{application.email || '-'}</td>
                                                        <td>{application.phone || '-'}</td>
                                                        <td>{application.location || '-'}</td>
                                                        <td className="text-center">
                                                            {application.resume ? (
                                                                <Button variant="outline-primary" size="sm" className="p-1 px-2" onClick={() => handleDownloadResume(application.id, application.resume)} title={`Download ${application.resume}`}>
                                                                    <i className="fas fa-download small"></i>
                                                                </Button>
                                                            ) : (<span className="text-muted small">N/A</span>)}
                                                        </td>
                                                        <td className="text-center">
                                                            <Button variant="outline-info" size="sm" className="me-1 p-1 px-2" onClick={() => handleViewDetails(application)} title="Check Results & Status">
                                                                <i className="fas fa-clipboard-check small"></i>
                                                            </Button>
                                                            <Button variant="outline-secondary" size="sm" className="p-1 px-2" onClick={() => handleViewApplicantDetails(application.id)} title="View Full Applicant Details">
                                                                <i className="fas fa-user small"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr><td colSpan="8" className="text-center p-5 text-muted fst-italic">{applicationList.length === 0 && !isLoading ? "No applicants found." : "No applicants match the current filters."}</td></tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                                {renderPaginationFooter()}
                            </Card.Body>
                        </Card>
                    </div>

                    {/* --- Modals --- */}
                    {showModal && selectedApplicant && (
                        <ApplicantModal
                            applicant={selectedApplicant}
                            jobapplications={jobapplications}
                            setSuccessMessage={setSuccessMessage}
                            updateJobApplication={updateJobApplicationStatusInList}
                            key={`modal-${selectedApplicant.id}-${jobapplications.length}`}
                        />
                    )}

                    {showDetailsModal && (
                        <ApplicantDetailsModal
                            show={showDetailsModal}
                            onHide={() => setShowDetailsModal(false)}
                            applicant={selectedApplicantDetails}
                            isLoading={!selectedApplicantDetails && showDetailsModal}
                        />
                    )}

                </main>
            </div>
        </>
    );
}